const PRIVATE_KEYS = [
  'creatorEmail',
  'email',
  'password',
  'phone',
  'token',
  'apiKey',
  'secret',
  'accessToken',
  'refreshToken',
] as const

function omitPrivateFields<T extends Record<string, unknown>>(record: T): T {
  const next = { ...record }
  for (const key of PRIVATE_KEYS) {
    delete next[key]
  }
  return next
}

export function sanitizeProfile<T extends Record<string, unknown> | null | undefined>(profile: T): T {
  if (!profile) return profile
  return omitPrivateFields(profile)
}

export function sanitizeProfiles<T extends Record<string, unknown>>(profiles: T[] | null | undefined): T[] {
  return (profiles || []).map(item => omitPrivateFields(item))
}

export function sanitizeCard<T extends Record<string, unknown> | null | undefined>(card: T): T {
  if (!card) return card
  return omitPrivateFields(card)
}

export function sanitizeCards<T extends Record<string, unknown>>(cards: T[] | null | undefined): T[] {
  return (cards || []).map(item => omitPrivateFields(item))
}

export function publicProfilePayload(data: Record<string, unknown>) {
  const {
    creatorEmail: _creatorEmail,
    email: _email,
    password: _password,
    phone: _phone,
    token: _token,
    apiKey: _apiKey,
    secret: _secret,
    ...safe
  } = data
  return safe
}

export function publicCardPayload(data: Record<string, unknown>) {
  const {
    creatorEmail: _creatorEmail,
    email: _email,
    password: _password,
    phone: _phone,
    token: _token,
    apiKey: _apiKey,
    secret: _secret,
    ...safe
  } = data
  return safe
}
